import { useEffect, useRef, useState, memo } from "react";
import { getAll } from "../../api/API";
import { useNavigate } from "react-router-dom";

const ScrollEvents = ({ selectedEventId }) => {
  const [events, setEvents] = useState([]);
  const navigate = useNavigate();
  const hasFetchedRef = useRef(false);

  // Normalize image URLs
  const resolveImage = (url) => {
    if (!url) return "/assets/images/default.jpg";
    if (url.startsWith("http")) return url;
    return `${process.env.REACT_APP_API_URL}${url}`;
  };

  useEffect(() => {
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;

    async function fetchEvents() {
      try {
        const data = await getAll("/public/events?limit=20&sort=-dateFrom");

        setEvents(data.docs || []);
      } catch (error) {
        console.error("Failed to fetch public events:", error);
      }
    }

    fetchEvents();
  }, []);

  const formatEventDate = (dateFrom, dateTo) => {
    if (!dateFrom) return "TBA";

    const start = new Date(dateFrom);
    const end = dateTo ? new Date(dateTo) : null;
    const options = { day: "2-digit", month: "short" };

    if (end && start.toDateString() === end.toDateString()) {
      return start.toLocaleDateString("en-GB", options).toUpperCase();
    }

    if (end) {
      return `${start
        .toLocaleDateString("en-GB", options)
        .toUpperCase()} - ${end
        .toLocaleDateString("en-GB", options)
        .toUpperCase()}`;
    }

    return start.toLocaleDateString("en-GB", options).toUpperCase();
  };

  const filteredEvents = events
    .filter((event) => event.eventId !== selectedEventId)
    .slice(0, 3);

  return (
    <div className="container my-4">
      {filteredEvents.length > 0 ? (
        filteredEvents.map((event) => (
          <div
            key={event.eventId}
            className="card mb-4 border-0 shadow-sm rounded-4 bg-primary text-white"
          >
            <div className="row g-0 align-items-stretch">
              {/* Left Side */}
              <div className="col-md-8 col-12 d-flex flex-column justify-content-between p-4">
                <div>
                  <h2
                    className="fw-bold mb-3 bg-tertiary"
                    style={{
                      display: "inline-block",
                      padding: "4px 10px",
                      borderRadius: "6px",
                    }}
                  >
                    {formatEventDate(event.dateFrom, event.dateTo)},{" "}
                    {event.venue?.toUpperCase() ?? "ONLINE"}
                  </h2>

                  <h6 className="fw-bold mb-2">{event.name}</h6>
                </div>

                <button
                  className="btn btn-success mt-3 bg-secondary text-primary"
                  onClick={() => navigate(`/events/${event.eventId}`)}
                >
                  View Details
                </button>
              </div>

              {/* Right Side */}
              <div className="col-md-4 col-12 d-flex align-items-center justify-content-end p-3">
                <img
                  src={resolveImage(event.image?.url)}
                  alt={event.name}
                  style={{
                    width: "130px",
                    height: "150px",
                    objectFit: "contain",
                    borderRadius: "8px",
                    backgroundColor: "white",
                  }}
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        ))
      ) : (
        <p className="text-secondary text-center">No events available.</p>
      )}
    </div>
  );
};

export default memo(ScrollEvents);
